module.exports = __webpack_public_path__ + "09.png?ded2624ea06057b04b9faf2b9c63e203";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshots/09.png
// module id = 123
// module chunks = 3